import React, { PureComponent } from "react"
import checkRole from "../../utils/checkRole"
import { connect } from "react-redux"
import { logoutAction } from "../../store/actionCreators"
import PropTypes from "prop-types"
import { message } from "antd"

class Home extends PureComponent {
  render() {
    return (
      <div>
        <h2>home</h2>
        <button onClick={() => this.logout()}>退出登录</button>
      </div>
    )
  }
  logout() {
    let localStorage = window.localStorage
    localStorage.token = ""
    localStorage.hasLogin = ""
    this.props.logout()
    message.success("退出登录成功！")
    this.props.history.replace("/")
  }
}
Home.propTypes = {
  logout: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
}

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch) => ({
  logout: () => {
    dispatch(logoutAction())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(checkRole(Home))
